import {
  productCardBleStarterM,
  productCardBleStarterD,
  productCardBleEnterpriseM,
  productCardBleEnterpriseD,
  productCardAoaStarterM,
  productCardAoaStarterD,
  productCardAoaEnterpriseM,
  productCardAoaEnterpriseD,
  productCardUwbStarterM,
  productCardUwbStarterD,
  productCardUwbEnterpriseM,
  productCardUwbEnterpriseD,
  productCardComfortM,
  productCardComfortD,
  productCardAiStarterM,
  productCardAiStarterD,
  productCardAiServerM,
  productCardAiServerD,
  productCardVehicleM,
  productCardVehicleD,
  productCardYardM,
  productCardYardD,
  productCardCameraM,
  productCardCameraD,
  productCardOutdoorM,
  productCardOutdoorD,
  productCardRtlsM,
  productCardRtlsD,
  productCardAccessM,
  productCardAccessD,
  productCardIotM,
  productCardIotD,
  productCardOrbroOsM,
} from '@assets/images/main/home/products/all';
import { iotBannerProduct } from '@assets/images/main/sensor';

import {
  aoaEnterpriseKit,
  aoaStarterKit,
  assetTracking1,
  bleEnterpriseKit,
  bleStarterKit,
  comfortKit1,
  uwbEnterpriseKit,
  uwbStarterKit,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import { carTracking1, peopleTracking1 } from '@assets/images/main/camera';
export default {
  assetPackage: {
    label: 'Assets Tracking Package',
    title: '资产定位套餐',
    product: 'TwinTracker 10 + Server 1',
    desc: '通过将BLE设备附加到工人或设备上，提供实时定位的产品。',
    img: assetTracking1,
    link: '/cn/rtls',
    index: '1',
  },

  workerPackage: {
    label: 'Workers Tracking Package',
    title: '工人定位套餐',
    product: 'TwinTrackerPro 10 + Server 1',
    desc: '通过将UWB设备附加到工人或设备上，提供实时定位的产品。',
    img: workerTracking1,
    link: '/cn/rtls',
    index: '2',
  },

  carPackage: {
    label: 'Vehicle Location Tracking Package',
    title: '车辆定位套餐',
    product: 'Server1 + NVR1 + PTZ Camera2',
    desc: '通过摄像头检测和管理人员、车辆等多种对象的位置和异常行为。',
    img: carTracking1,
    link: '/cn/camera',
    index: '1',
  },

  peoplePackage: {
    label: 'People Tracking and Analysis Package',
    title: '人员定位与分析套餐',
    product: 'Server1 + NVR1 + IP Camera4',
    desc: '通过摄像头分析室内人员的移动路径和检测突发事件。',
    img: peopleTracking1,
    link: '/cn/camera',
    index: '2',
  },

  recommand: '推荐产品',

  cards: [
    {
      title: 'TwinTracker BLE 入门套件',
      desc: 'ORBRO Edge RTLS，L2 交换机，TwinTracker BLE（4个）',
      link: '/rtls/ble',
      img: { desktop: productCardBleStarterD, tablet: productCardBleStarterM, mobile: productCardBleStarterM },
    },
    {
      title: 'BLE 企业套件',
      desc: 'ORBRO 服务器，L2 交换机（2个），ORBRO Edge RTLS（2个），TwinTracker BLE（12个）',
      link: '/rtls/ble',
      img: { desktop: productCardBleEnterpriseD, tablet: productCardBleEnterpriseM, mobile: productCardBleEnterpriseM },
    },
    {
      title: 'TwinTracker AoA 入门套件',
      desc: 'ORBRO Edge RTLS，L2 交换机，TwinTracker AoA（4个）',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaStarterD, tablet: productCardAoaStarterM, mobile: productCardAoaStarterM },
    },
    {
      title: 'AoA 企业套件',
      desc: 'ORBRO 服务器，L2 交换机（2个），ORBRO Edge RTLS（2个），TwinTracker AoA（12个）',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaEnterpriseD, tablet: productCardAoaEnterpriseM, mobile: productCardAoaEnterpriseM },
    },
    {
      title: 'TwinTracker UWB 入门套件',
      desc: 'ORBRO 服务器，L2 交换机（2个），ORBRO Edge RTLS（2个），TwinTracker BLE（12个）',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbStarterD, tablet: productCardUwbStarterM, mobile: productCardUwbStarterM },
    },
    {
      title: 'UWB 企业套件',
      desc: 'ORBRO 服务器，L2 交换机（2个），ORBRO Edge RTLS（2个），TwinTracker UWB（12个）',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbEnterpriseD, tablet: productCardUwbEnterpriseM, mobile: productCardUwbEnterpriseM },
    },
    {
      title: 'Comfort 套件',
      desc: '移动应用，UWB 标签（8个），UWB 标签',
      link: '/rtls/comfort',
      img: { desktop: productCardComfortD, tablet: productCardComfortM, mobile: productCardComfortM },
    },
    {
      title: 'ORBRO Edge AI 入门套件',
      desc: 'ORBRO Edge AI，L2 交换机',
      link: '/camera/edge',
      img: { desktop: productCardAiStarterD, tablet: productCardAiStarterM, mobile: productCardAiStarterM },
    },
    {
      title: 'ORBRO AI 服务器企业套件',
      desc: 'ORBRO AI 服务器，ORBRO 服务器',
      link: '/camera/server',
      img: { desktop: productCardAiServerD, tablet: productCardAiServerM, mobile: productCardAiServerM },
    },
    {
      title: '车辆追踪套件',
      desc: 'ORBRO 服务器 x 1 + GPS 设备 x 5',
      link: '/outdoor/gps',
      img: { desktop: productCardVehicleD, tablet: productCardVehicleM, mobile: productCardVehicleM },
    },
    {
      title: '堆场追踪套件',
      desc: 'ORBRO 服务器，LoRa 网关，GPS 标签（10个）',
      link: '/outdoor/lora',
      img: { desktop: productCardYardD, tablet: productCardYardM, mobile: productCardYardM },
    },
    {
      title: '视频定位追踪',
      desc: '基于 AI 的视频对象追踪',
      link: '/camera',
      img: { desktop: productCardCameraD, tablet: productCardCameraM, mobile: productCardCameraM },
    },
    {
      title: '户外位置追踪',
      desc: '车辆及堆场位置追踪',
      link: '/outdoor',
      img: { desktop: productCardOutdoorD, tablet: productCardOutdoorM, mobile: productCardOutdoorM },
    },
    {
      title: '无线位置追踪',
      desc: '基于 BLE、AoA、UWB 等无线通信的位置追踪',
      link: '/rtls',
      img: { desktop: productCardRtlsD, tablet: productCardRtlsM, mobile: productCardRtlsM },
    },
    {
      title: '出入口控制系统',
      desc: '自动门、人脸识别等出入控制',
      link: '/access',
      img: { desktop: productCardAccessD, tablet: productCardAccessM, mobile: productCardAccessM },
    },
    {
      title: 'Industry IoT',
      desc: '连接空气质量、一氧化碳传感器、LoRa 网关、机器人等',
      link: '/iot',
      img: { desktop: productCardIotD, tablet: productCardIotM, mobile: productCardIotM },
    },
    {
      type: 'orbroOs',
      title: 'ORBRO OS',
      desc: 'All Spaces, All Devices, Connected at a Glance on a Digital Platform',
      link: '/os',
      img: {
        desktop: productCardOrbroOsM,
        tablet: productCardOrbroOsM,
        mobile: productCardOrbroOsM,
      },
    },
  ],
};
